import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { LabelValueList } from '~/@mid_ui/label-value/LabelValueList'
import { PhoneNumberChangeDialog } from '../contact-info_change-phone-number/ChangePhoneNumberDialog'
import { getContactInfoItems } from './conactInfoItems'
import { useUser } from '~/@biz_account/useUser/useUser'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'

function ContactInfo() {
  const { user, isUserApproved, reloadUser } = useUser()
  const { setNotification } = useLocalNotifications()

  const contactInfoItems = getContactInfoItems(user?.profile)

  return (
    <div className="flex flex-col last:grow w-full pt-10 pb-15">
      <PageContainer className="flex flex-col gap-10 md:pl-40 md:pr-15">
        <HeadingThree>Kontaktné údaje</HeadingThree>
        <LabelValueList
          items={contactInfoItems}
          itemClassName="flex flex-col lg:flex-row lg:gap-3 justify-start"
        />

        <div className="w-full">
          <PhoneNumberChangeDialog
            disabled={!isUserApproved}
            onPhoneNumberChanged={() => {
              reloadUser()
              setNotification('success', 'Telefónne číslo bolo zmenené')
            }}
          />
        </div>
      </PageContainer>
    </div>
  )
}

export { ContactInfo }
